<template>
    <div class="v-back">
        <router-link
            v-if="isRouter"
            :to="url"
        >
            <v-icon name="back" /><span class="link-text"><slot /></span>
        </router-link>
        <a
            v-else
            :href="url"
        >
            <v-icon name="back" /><span class="link-text"><slot /></span>
        </a>
        <div
            v-if="pageTitle"
            class="content-title"
        >
            {{ pageTitle }}
        </div>
    </div>
</template>
<script>
import { Icon } from 'vhtml-ui';

const req = require.context('../../../assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);
export default {
  name: 'Back',
  components: {
    VIcon: Icon,
  },
  props: {
    pageTitle: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: '',
    },
    isRouter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less">
.v-back {
    margin-top: 16px;
    a {
        text-decoration: none;
        color: #a8abb3;
        font-size: 14px;
        cursor: pointer;
        &:hover {
            color: #1e2330;
        }
        .v-icon {
            height: 16px;
            width: 10px;
            vertical-align: -4px;
        }
    }
    .content-title {
        font-size: 24px;
        height: 24px;
        line-height: 24px;
        padding-top: 28px;
        overflow: hidden;
        margin-top: 6px;
    }
}
</style>
